<template>
<div class="empty">
  <img class="empty-img" src="@/assets/images/empty.png" alt="">
  <div class="empty-txt">信息完善中...</div>
</div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.empty {
  width: 900px;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;

  .empty-txt {
    font-size:16px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(59,59,88,1);
    line-height:24px;
    margin-top: 16px;
  }

  .empty-img {
    width: 99px;
    height: 85px;
  }
}
</style>
